/**
 * Created by Adam on 15/12/2016.
 */

if (window.jQuery) {
    window.jQuery(function ($) {

        var selector = '.hotel-content',
            elements = $(selector);
        if (elements.length>0)
        {
            trackCTA('hotel_card_in_page',elements.length.toString());
        }
        elements.each(function (i, e) {
            var element = $(e),
                amenitiesList=$(element.find('.hotel-amenities-list')),
                children = amenitiesList.children(),
                numberOfAmenities = children.length,
                amenityButton=$(element.find('.hotel-amenity-button')),
                hotelTitle=$(element.find('.hotel-title')).text(),
                bookButton=$(element.find('.hotel-deep-link-section'));

            if (numberOfAmenities<3)
                return true;

            bookButton.one('click',function(){
                trackCTA('hotel_card_book_clicked',hotelTitle);
            });
            amenityButton.click(function(){
                var buttonClicked=$(amenityButton).attr('data-click'),
                    buttonText=$($(amenityButton).find('.btt-description')),
                    buttonIcon=$($(amenityButton).find('.material-icons'));

                if (buttonClicked=='true'){
                    trackCTA('hotel_card_less_clicked',hotelTitle);
                    $(amenityButton).attr('data-click','false');
                    buttonText.text('more');
                    buttonIcon.text('keyboard_arrow_down');
                    amenitiesChangeDisplay();

                }
                else {
                    trackCTA('hotel_card_more_clicked',hotelTitle);
                    $(amenityButton).attr('data-click','true');
                    buttonText.text('less');
                    buttonIcon.text('keyboard_arrow_up');
                    amenitiesChangeDisplay();
                }
            });

            function amenitiesChangeDisplay(){
                amenitiesList   .toggleClass('open');
            }


        });

    });
}